module.exports = __webpack_public_path__ + "img/summary-1.0fc69482.svg";